import { useSectionState } from './SectionStateContext';
import { DraggableFloatingModal } from '../floating-modal/DraggableFloatingModal';
import { FloatingModalContainerProps } from './util';

export function FloatingModalContainer({
  sectionsContent,
}: FloatingModalContainerProps) {
  const { sections, toggleSection } = useSectionState();
  const detachedSections = Object.values(sections).filter(
    (section) => section.isDetached
  );
  if (detachedSections.length === 0) {
    return null;
  }

  return (
    <>
      {detachedSections.map((section) => {
        const sectionContent = sectionsContent[section.id];
        if (!sectionContent) return null;

        const basePosition = section.position || { top: 100, left: 100 };
        return (
          <DraggableFloatingModal
            key={section.id}
            isOpen={true}
            onClose={() => toggleSection(section.id)}
            title={sectionContent.title}
            initialPosition={basePosition}
          >
            {sectionContent.content}
          </DraggableFloatingModal>
        );
      })}
    </>
  );
}
